import smoothScroll from './functions/_smoothScroll.js' // スムーズスクロール
import { Autoplay, Controller, EffectFade, Navigation, Pagination, Swiper } from 'swiper'
Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination]) // Swiper宣言
// その他、Swiperで使う機能があったら上に追加で宣言する
// A11y, Autoplay, Controller, EffectCoverflow, EffectCube, EffectFade, EffectFlip, HashNavigation, History, Keyboard, Lazy, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom,

if (document.getElementById('page-top')) {
  pageTop()
}

function pageTop() {
  //   ####   ####  #####     #####   ##      ##
  //  ##     ##     ##  ##   ##   ##  ##      ##
  //   ###   ##     #####    ##   ##  ##      ##
  //     ##  ##     ##  ##   ##   ##  ##      ##
  //  ####    ####  ##   ##   #####   ######  ######

  // スムーズスクロール開始
  new smoothScroll({
    deceleration: 0.1, // 減速率
  })

  //  ##  ##     ##  ######             #####   #####    ####
  //  ##  ####   ##    ##              ##   ##  ##  ##  ##
  //  ##  ##  ## ##    ##    ########  ##   ##  #####    ###
  //  ##  ##    ###    ##              ##   ##  ##  ##     ##
  //  ##  ##     ##    ##               #####   #####   ####
  window.addEventListener('load', function (e) {
    setTimeout(() => {
      window.intObs('-35% 0px')
    }, 300)
  })

  //  ###    ###  ##   ##
  //  ## #  # ##  ##   ##
  //  ##  ##  ##  ##   ##
  //  ##      ##   ## ##
  //  ##      ##    ###

  // Swiperコンテナを検出したら実行
  // eslint-disable-next-line no-unused-vars

  const slideItem = document.getElementById('topMv')

  // 各要素を取得
  const slideWrap = slideItem.querySelector('.swiper-wrapper')
  const slideList = slideItem.querySelectorAll('.swiper-slide')
  let slideCount = slideList.length // スライドの数

  const slidePerViewMax = 0 * 3 // ループ表示に必要なスライド数　slidesPerViewの2倍
  // ループに不足するスライドを補充する
  while (slideCount < slidePerViewMax) {
    for (const iterator of slideList) {
      const clone = iterator.cloneNode(true)
      slideWrap.appendChild(clone)
      ++slideCount
    }
  }

  const sliderName = 'topMv'
  const topMvSwiper = new Swiper(slideItem, {
    init: false, // 自動で初期化しない（topMvSwiper.init()で初期化）
    effect: 'fade', // slide,fade,cube,coverflow
    speed: 1000, // アニメ速度
    loop: true, // ループ
    // loopAdditionalSlides: 10, //ループ演出用のクローン数を増やして安定化させる
    preloadImages: false, // スライド内の画像を読み終えてから開始

    // autoHeight: true, // スライドごとに高さを変動させる
    fadeEffect: {
      // フェードオプション
      crossFade: true, // クロスフェード
    },

    autoplay: {
      // オートオプション
      delay: 5000, // 待機時間
      disableOnInteraction: false, // 操作されたら停止する
    },
  })

  //  ###    ###  ##   ##            ######  #####  ##    ##  ######
  //  ## #  # ##  ##   ##              ##    ##      ##  ##     ##
  //  ##  ##  ##  ##   ##  ########    ##    #####    ####      ##
  //  ##      ##   ## ##               ##    ##      ##  ##     ##
  //  ##      ##    ###                ##    #####  ##    ##    ##

  const mvBox = document.getElementById('mvBox')
  mvBox.addEventListener('transitionend', function (e) {
    mvTextActive()
  })
  mvBox.addEventListener('webkitTransitionend', function (e) {
    mvTextActive()
  })

  function mvTextActive() {
    topMvSwiper.init()
    document.getElementById('mvText').classList.add('js-in')
    window.intObs('-35% 0px')
  }

  //  ##   ##             ####  ##   ##  ##  #####  ######
  //  ##   ##            ##     ##   ##  ##  ##       ##
  //  #######  ########   ###   #######  ##  #####    ##
  //  ##   ##               ##  ##   ##  ##  ##       ##
  //  ##   ##            ####   ##   ##  ##  ##       ##

  /*
  ホバー中、その要素とその連動要素全てに.animatedを付与

  <a href="" class="js-hoverShift js-hoverShift--hoge" data-hover-shift="hoge"></a>
  <a href="" class="js-hoverShift js-hoverShift-target js-hoverShift--hoge" data-hover-shift="hoge"></a>
  */
  const hoverShiftClass = 'js-hoverShift'
  if (document.getElementsByClassName(hoverShiftClass)[0]) {
    hoverShift()
  }
  function hoverShift() {
    const hoverActiveClass = 'animated'
    const hoverItems = document.getElementsByClassName(hoverShiftClass)
    for (let index = 0; index < hoverItems.length; index++) {
      const hoverItem = hoverItems[index]
      const hoverGroup = document.getElementsByClassName(hoverShiftClass + '-target')
      const hoverTargets = document.getElementsByClassName(hoverShiftClass + '--' + hoverItem.dataset.hoverShift)
      hoverItem.addEventListener(
        'mouseover',
        function () {
          for (const iterator of hoverGroup) {
            iterator.classList.remove(hoverActiveClass)
          }
          for (let index = 0; index < hoverTargets.length; index++) {
            hoverTargets[index].classList.add(hoverActiveClass)
          }
        },
        false
      )
    }
  }

  //  #####  #####     #####   ##     ##  ######
  //  ##     ##  ##   ##   ##  ####   ##    ##
  //  #####  #####    ##   ##  ##  ## ##    ##
  //  ##     ##  ##   ##   ##  ##    ###    ##
  //  ##     ##   ##   #####   ##     ##    ##

  if (document.getElementById('topFront')) {
    // Swiperコンテナを検出したら実行
    // eslint-disable-next-line no-unused-vars

    // 各要素を取得
    const slideItem = document.getElementById('topFront')
    const slideWrap = slideItem.querySelector('.swiper-wrapper')
    const slideList = slideItem.querySelectorAll('.swiper-slide')
    let slideCount = slideList.length // スライドの数

    const slidePerViewMax = 4 * 3 // ループ表示に必要なスライド数　slidesPerViewの3倍
    // ループに不足するスライドを補充する
    while (slideCount < slidePerViewMax) {
      for (const iterator of slideList) {
        const clone = iterator.cloneNode(true)
        slideWrap.appendChild(clone)
        ++slideCount
      }
    }

    const sliderName = 'topFront'
    const topFrontSwiper = new Swiper(slideItem, {
      effect: 'slide', // slide,fade,cube,coverflow
      speed: 500, // アニメ速度
      loop: true, // ループ
      slidesPerView: 1.4, //表示数変更 小数指定可　'auto' + .swiper-slide{width:auto;}で可変化
      spaceBetween: 0, //スライド同士の間隔を空ける
      // slideToClickedSlide: true, // クリックしたスライドをアクティブにする
      centeredSlides: true, // 中央のスライドを基準にする
      coverflowEffect: {
        depth: 100,
        rotate: 30,
        slideShadows: false,
        scale: 2,
      },
      autoplay: {
        // オートオプション
        delay: 5000, // 待機時間
        disableOnInteraction: false, // 操作されたら停止する
        // pauseOnMouseEnter: true, // マウスオーバー中は一時停止する
        // stopOnLastSlide: true, // 最終スライドに到達したら停止する
      },

      navigation: {
        nextEl: '.swiper-button-next--' + sliderName, // 前のページボタンを呼び出す要素
        prevEl: '.swiper-button-prev--' + sliderName, // 次のページボタンを呼び出す要素
      },
      breakpoints: {
        // 指定px以上でオプション切り替え
        769: {
          slidesPerView: 3.4, //表示数変更 小数指定可　'auto' + .swiper-slide{width:auto;}で可変化
        },
      },
    })
  }
}
